import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';
import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { NewsletterStyle } from '@website-builder/widgets/newsletter/model/newsletter-style';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class NewsletterWidget extends BaseWidget<NewsletterStyle> {
  readonly type = BuilderElementType.Newsletter;
  style = new NewsletterStyle();
  showNameFields = true;
  firstName: string;
  lastName: string;
  email: string;
  firstNameLabel = 'First name';
  lastNameLabel = 'Last name';
  emailNameLabel = 'Email address';
  buttonLabel = 'Subscribe';
  buttonStyle = new GlobalButtonStyle();
  showMessage = true;
  successMessage = `You've been subscribed successfully.`;

  static normalizeInPlace(widget: NewsletterWidget): NewsletterWidget {
    const pureWidget = new NewsletterWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.showNameFields = widget.showNameFields ?? pureWidget.showNameFields;
    widget.firstName = widget.firstName ?? pureWidget.firstName;
    widget.lastName = widget.lastName ?? pureWidget.lastName;
    widget.email = widget.email ?? pureWidget.email;
    widget.firstNameLabel = widget.firstNameLabel ?? pureWidget.firstNameLabel;
    widget.lastNameLabel = widget.lastNameLabel ?? pureWidget.lastNameLabel;
    widget.emailNameLabel = widget.emailNameLabel ?? pureWidget.emailNameLabel;
    widget.buttonLabel = widget.buttonLabel ?? pureWidget.buttonLabel;
    widget.showMessage = widget.showMessage ?? pureWidget.showMessage;
    widget.successMessage = widget.successMessage ?? pureWidget.successMessage;

    widget.style = NewsletterStyle.normalize(widget.style);
    widget.buttonStyle = GlobalButtonStyle.normalize(widget.buttonStyle);

    return widget;
  }
}
